"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _pfComponentLibrary = require("@pf-loan-funnel/pf-component-library");
/* eslint-disable import/no-unresolved */

var CTAs = function CTAs(_ref) {
  var onConfirmApplyClick = _ref.onConfirmApplyClick,
    _ref$onChooseAnotherO = _ref.onChooseAnotherOptionClick,
    onChooseAnotherOptionClick = _ref$onChooseAnotherO === void 0 ? null : _ref$onChooseAnotherO;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pf-confirm-apply__ctas"
  }, /*#__PURE__*/_react.default.createElement(_pfComponentLibrary.Button.Primary, {
    "data-test-id": "confirm-and-apply",
    onClick: onConfirmApplyClick
  }, "Confirm and Apply"), onChooseAnotherOptionClick && /*#__PURE__*/_react.default.createElement(_pfComponentLibrary.Button.Secondary, {
    "data-test-id": "back-to-offers",
    onClick: onChooseAnotherOptionClick
  }, "Choose Another Option"));
};
CTAs.propTypes = {
  onConfirmApplyClick: _propTypes.default.func.isRequired,
  onChooseAnotherOptionClick: _propTypes.default.func.isRequired
};
var _default = exports.default = CTAs;
